module.exports = __webpack_public_path__ + "assets/img/commission3.b8eb5525.svg";